export class UserCredentials {
	username: string;
	password: string;
	token: string;
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/domain-models/UserCredentials.ts